<template>
  <div>
      <vue-header title="我的套餐"/>
      <div class="record-tool" v-for="meal in mealData" v-bind:key="meal.id">
        <div class="record-box flex flex-y">
            <div class="record-title">
                {{meal.set_meal.name}}
            </div>
            <div class="flex-1">
                <div>套餐次数：<span>{{meal.set_meal.counts}}次</span></div>
            </div>
            <div>剩余次数：<span>{{meal.set_meal.counts-meal.set_meal.stock_use_count}}次</span></div>
        </div>
        <div class="record-date flex">
            <div class="flex-1">购买：{{timeSubmit(meal.set_meal.created_at)}}</div>
            <div v-if="meal.disease">专项理疗：{{meal.disease.name}}</div>
        </div>
      </div>
  </div>
</template>
<script>
import vueHeader from '@/components/header';
import { mapActions , mapState } from 'vuex';
import { titleFun } from '@/utils';
//let timer;
export default {
  name: 'mySubscribe',
  components:{
    vueHeader
  },
  created:function(){
      this.userMealMain({
        id:this.$route.params.id
      });
      titleFun('我的套餐');
      //window.addEventListener('scroll', this.onSrollFun)
  },
  // destroyed: function () {
  //     window.removeEventListener('scroll', this.onSrollFun, false);
  // },
  computed:{
      ...mapState('my',['mealData']),
  },
  methods:{
      // onSrollFun(){
      //       let _this = this;
      //       clearTimeout(timer);
      //       timer = setTimeout(()=>{
      //           let height = document.documentElement.scrollHeight-document.documentElement.scrollTop-document.documentElement.clientHeight;
      //           //获取滚动条到底部的距离
      //           if(height<1000){
      //               console.log(123,_this);
      //           }
      //       },1000)
      // },
      timeSubmit(value){
        let date = new Date(value);
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return `${y}-${m}-${d}`;
      },
      ...mapActions('my',['userMealMain'])
  }
}
</script>

<style lang="scss" scoped>
  @import './myMeal';
</style>